import React from "react";

export function SectionHeader({ icon: Icon, title, subtitle }) {
  return (
    <div
      data-testid={`section-header-${title.toLowerCase().replace(/\s+/g, "-")}`}
      className="flex items-center gap-3 pt-4 pb-1 border-b border-slate-800/60"
    >
      {Icon && (
        <div className="p-1.5 bg-slate-800/60 rounded-md">
          <Icon className="w-4 h-4 text-amber-400" />
        </div>
      )}
      <div>
        <h2 className="text-base font-semibold text-white tracking-wide uppercase">
          {title}
        </h2>
        {subtitle && (
          <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
